import { GroupActionTypes } from "./group-types";

const INITIAL_STATE = {
  allGroups: null,
  searchGroupsQuery: {
    pageSize: 10,
    pageNumber: 1,
    sortDesc: false,
    sortBy: "name",
    filters: [],
  },
  isFetchingGroups: false,
  isFetchingAllGroups: false,
  groups: null,
  numGroups: 0,
  selectedGroups: [],
  groupsOnPage: null,
};

const groupReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GroupActionTypes.FETCH_GROUPS_START:
      return {
        ...state,
        isFetchingGroups: true,
      };
    case GroupActionTypes.FETCH_GROUPS_SUCCESS:
      return {
        ...state,
        isFetchingGroups: false,
        groups: action.payload[0],
        numGroups: action.payload[1],
      };
    case GroupActionTypes.FETCH_GROUPS_FAILURE:
      return {
        ...state,
        isFetchingGroups: false,
        errorMessage: action.payload,
      };
    case GroupActionTypes.SET_GROUPS_ON_PAGE: //setting the groups that are displayed on the page
      return {
        ...state,
        groupsOnPage: action.payload,
      };

    case GroupActionTypes.SET_SEARCH_GROUPS_QUERY:
      return {
        ...state,
        searchGroupsQuery: action.payload,
      };

    case GroupActionTypes.ADD_SELECTED_GROUP:
      return {
        ...state,
        selectedGroups: [...state.selectedGroups, action.payload],
      };

    case GroupActionTypes.DELETE_SELECTED_GROUP:
      return {
        ...state,
        selectedGroups: [
          ...state.selectedGroups.slice(
            0,
            state.selectedGroups.indexOf(action.payload)
          ),
          ...state.selectedGroups.slice(
            state.selectedGroups.indexOf(action.payload) + 1
          ),
        ],
      };
    case GroupActionTypes.SET_SELECTED_GROUP:
      return {
        ...state,
        selectedGroups: action.payload,
      };

    default:
      return state;
  }
};

export default groupReducer;
